import { Injectable } from '@angular/core';
import { HttpClient,  HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, ReplaySubject, Subject, throwError } from 'rxjs';
import { catchError, retry} from 'rxjs/operators';
import { Title, Meta, MetaDefinition } from '@angular/platform-browser';
import { environment } from '../../environments/environment';
import { active_session_details } from './users.service';
import { CookieService } from 'ngx-cookie-service';

const cookieService = CookieService;

@Injectable({
  providedIn: 'root'
})
 
export class BusinessGroupManagementService {
  error_message: any;

  constructor(private http: HttpClient, private title: Title, private meta: Meta, private cookieService: CookieService) { }

  options = { headers: new HttpHeaders ({ 'Content-Type': 'application/json' }) }

  BusinessgroupTable(page_size,page_no, searchStr):Observable<any>{
    
    return this.http.get<any>(environment.apiURL+"/business_group?auth_token=gfbNXDBbsmijpxAzgStY"+"&active_session="+active_session_details.active_session+`&page_no=${page_no}&page_size=${page_size}&title=${searchStr}`, this.options)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  getBgDetailsByID(bg_id):Observable<any>{
    
    return this.http.get<any>(environment.apiURL+"get_bg?bg_id="+bg_id+"&auth_token=gfbNXDBbsmijpxAzgStY"+"&active_session="+active_session_details.active_session, this.options)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  addBusinessGroup(data):Observable<any>{
    return this.http.post<any>(environment.apiURL+"business_group?auth_token=gfbNXDBbsmijpxAzgStY"+"&active_session="+active_session_details.active_session, data, this.options)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  editBusinessGroup(bg_id,data):Observable<any>{
    return this.http.put<any>(environment.apiURL+"/update_bg?bg_id="+bg_id+"&auth_token=gfbNXDBbsmijpxAzgStY"+"&active_session="+active_session_details.active_session, data, this.options)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }
  
  switchTo(bg_id):Observable<any>{
    return this.http.get<any>(environment.apiURL+"/cms_users/switch_bg?bg_id="+bg_id+"&active_session="+active_session_details.active_session, this.options)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  handleCookieData(){
    return authtoken = this.cookieService.get('bg_authtoken') == '' ? environment.authtoken : this.cookieService.get('bg_authtoken');
    
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    //console.log(error);
    if (error.error instanceof ErrorEvent) {
       //console.log('client-side error')
      errorMessage = `Error: ${error.error.message}`;
    } else {
      //console.log('server-side error');
      //console.log(error);
      if(error.error.error.error_code){
        this.error_message = {
          server_error_code: error.error.error.error_code,
          server_error_messsage:error.error.error.error_message
        }
      }
      else if(error.error.error) {
        //console.log("error.error"+error.error)
        this.error_message = {
          server_error_code: error.error.error.code,
          server_error_messsage: error.error.error.message ? error.error.error.message : error.error.error
        }
      }
      else {
        //console.log("no:");
        this.error_message = {
          server_error_code: error.status,
          server_error_messsage: error.message
        }
      }
      //errorMessage = `server_error message: ${error.error.error.message}+Error Code: ${error.status}+Message: ${error.message}`;
      errorMessage = this.error_message;
    }
    return throwError(errorMessage);
  }
  
}

export let authtoken = "";

